import { Dialog } from "@mui/material";
import { Box, Button, Typography } from "@mui/material";
import AlertIcon from "../../utils/images/alert-02.svg";

export default function WarningDialog({ open, onClose, onConfirm, changeType }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
          maxWidth: "400px",
        },
      }}
    >
      <Box sx={{ padding: "24px" }}>
        <Box
          sx={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "#FFFAF6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <img
            src={AlertIcon}
            alt="Alert"
            style={{ width: "50px", height: "50px" }}
          />
        </Box>

        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#252D38",
            textAlign: "center",
            marginBottom: "8px",
          }}
        >
          {changeType === "billType" ? "Bill Type Changed" : "Unsaved Changes"}
        </Typography>

        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            color: "#47566A",
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          {changeType === "billType"
            ? "Changing the bill type will remove all saved data and documents. Are you sure you want to continue?"
            : "You have unsaved updates that will be lost. Do you want to go back to the confirmation page without saving?"}
        </Typography>

        <Box sx={{ display: "flex", gap: "12px" }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              flex: 1,
              color: "#47566A",
              borderColor: "#A4B0C0",
              borderRadius: "8px",
              padding: "10px 16px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              "&:hover": {
                borderColor: "#8A99AD",
                backgroundColor: "#F9FAFB",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              flex: 1,
              backgroundColor: "#D80008",
              color: "#FFFFFF",
              borderRadius: "8px",
              padding: "10px 16px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#DC2626",
              },
            }}
          >
            Yes, Continue
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};